module.exports = __webpack_public_path__ + "static/year-of-running-71cd47a62001d224d0adca28723e15be.jpg";